import { ManagementEnvironment } from './environment.type';

/** The dev server. */
export const environment: ManagementEnvironment = {
  keycloak: {
    url: 'https://dev.auth.upapi.co',
    realm: 'yearbook-master',
    clientId: 'canvas-management',
  },
  editorUrl: 'https://dev-app.canvas-builder.com',
  apiBase: 'https://dev.upapi.co/api/v1/canvas',
  kcIdentityProvider: 'yearbook-master',
  production: false,
};
